<div class='ui-g-12' *ngIf='this.show_results'>
  <div class='ui-g-3 card card-w-title' style='border: 2px solid #edf0f5;'>
    <app-infobox [pointData]='customers_profilables' [t]="'disable'"></app-infobox>
  </div>
  <div class='ui-g-3 card card-w-title' style='border: 2px solid #edf0f5;'>
    <app-infobox [pointData]='customers_active' [t]="'disable'"></app-infobox>
  </div>
  <div class='ui-g-3 card card-w-title' style='border: 2px solid #edf0f5;'>
    <app-infobox [pointData]='customer_lose' [t]="'disable'"></app-infobox>
  </div>
  <div class='ui-g-3 card card-w-title' style='border: 2px solid #edf0f5;'>
    <app-infobox [pointData]='customer_new' [t]="'disable'"></app-infobox>
  </div>

  <div class='ui-g-9 card card-w-title' style='border: 2px solid #edf0f5; height: 675px;'>
    <div style='width: 100%;'>
      <chart [options]='optionRevenueNoOfCustomers' style='display:block;' (load)='revenueNoOfCustomersChart($event.context)'></chart>
    </div>
  </div>
  <div>
    <div class='ui-g-3 card card-w-title' style='border: 2px solid #edf0f5;height: 225px;'>
      <app-infobox [pointData]='customer_percent_loyal_cards' [options]="{unit_period_prec:'%'}" [t]="'disable'"></app-infobox>
    </div>
    <div class='ui-g-3 card card-w-title' style='border: 2px solid #edf0f5; height: 225px;'>
      <app-infobox [pointData]='customer_percent_loyal_revenue' [options]="{unit_period_prec:'%'}" [t]="'disable'"></app-infobox>
    </div>
    <div class='ui-g-3 card card-w-title' style='border: 2px solid #edf0f5; height: 225px;'>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-value-overview/customer-value-overview.component.html